import React from 'react';

import CSS from './styles.scss';
import SortByMenu from './SortByMenu';
import FilterByMenu from './FilterByMenu';
import Button from 'Shared/Button';


const FilterBarViews = ({ isMobile, currentParentIndex, containerRef, goToNextMenu, goToNextMenuFromSubmenu, openFilterPanel, updateParentIndex }) => {
  return (
    <nav className={ CSS['container'] } ref={ containerRef }>
      <ul role="toolbar" aria-label="functions" className={ CSS['header'] }>
        <SortByMenu goToNextMenu={ goToNextMenu } goToNextMenuFromSubmenu={ goToNextMenuFromSubmenu } currentParentIndex={ currentParentIndex } updateParentIndex={ updateParentIndex }/>

        {!isMobile
          ? <FilterByMenu goToNextMenu={ goToNextMenu } goToNextMenuFromSubmenu={ goToNextMenuFromSubmenu } currentParentIndex={ currentParentIndex } updateParentIndex={ updateParentIndex }/>
          : <Button  className={ CSS['filter-button'] } label="Filter" onClick={ openFilterPanel } />
        }
      </ul>
    </nav>
  );
}


export default FilterBarViews;
